module.exports = __webpack_public_path__ + "static/media/paraffin_100_detail.58baf0e6.jpg";